import * as React from "react";
import Page from "../../components/Page";
import RouteWithSubRoutes from "../../components/RouteWithSubRoutes";
import WithAuth from "../../helpers/WithLoggedIn";

import StaticDataProvider from "../../helpers/StaticDataProvider";
import QuadrantProvider from "../../helpers/QuadrantProvider";
import { UserDataProvider } from "../../helpers/UserDataProvider";
import { RouteComponentProps, withRouter } from "react-router";
import * as GoogleAnalytics from "react-ga";

// Implmenting Analytics

interface Props extends RouteComponentProps<{}> {}

GoogleAnalytics.initialize("UA-97544462-3");

const trackPage = (page, opts?) => {
	// GoogleAnalytics.set({
	// 	page
	// 	// ...options
	// });
	GoogleAnalytics.pageview(page);
};

class BasePage extends React.Component<Props> {
	componentDidMount() {
		trackPage(this.props.location.pathname);
	}

	componentDidUpdate(prevProps: Props, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			// We navigated
			trackPage(this.props.location.pathname);
			console.log("Did navigate", this.props.location.pathname);
		}
	}

	render() {
		return (
			<WithAuth>
				<StaticDataProvider>
					<QuadrantProvider>
						<UserDataProvider>
							<Page>{this.props.children}</Page>
						</UserDataProvider>
					</QuadrantProvider>
				</StaticDataProvider>
			</WithAuth>
		);
	}
}

export default withRouter(BasePage);



// WEBPACK FOOTER //
// ./src/pages/BasePage/index.tsx